const AppRoutes = {
    ROOT : '/',
    LOGIN : '/Login',
    FORGOT_PASSWORD : '/ForgotPassword',
    RESET_PASSWORD : '/ResetPassword',
    HOME : '/Home',
    PROFILE : '/Profile',
    CART : '/Cart',
    ORDER_CONFIRM : '/OrderConfirmation'
}

export default AppRoutes;